import { localStorageSelectiveClean } from "../../../../utils/localStorageSelectiveClean";

import cookie from "js-cookie";
import { cache as swrCache } from "swr";
import { BONUSX_ACCESS_TOKEN } from "../../../../../constants/env";
import { queryClient } from "../../../../../lib/tankstack/providers/QueryClientProvider";
import mixpanel from "../../../../../lib/mixpanel/mixpanel.config";
import type { IJWTUserPayload } from "../../../../interfaces/JWTUserPayload";
import { authStateService } from "../../auth-state/auth-state.service.instance";
import type { IAuthStateService } from "../../auth-state/auth-state.service.interface";
import type { ILocalAuthenticationStorageDataSource } from "./local-authentication-storage.datasource.interface";

export class LocalAuthenticationStorageDataSource implements ILocalAuthenticationStorageDataSource {
  private readonly _COOKIE_DEFAULT_DOMAIN = new URL(window.location.href).hostname;

  constructor(private readonly _authStateService: IAuthStateService = authStateService) {}

  resetAuthenticationStorage(): void {
    localStorageSelectiveClean();
    swrCache.clear();
    queryClient.clear();
    cookie.remove(BONUSX_ACCESS_TOKEN, { path: "/", domain: `.${this._COOKIE_DEFAULT_DOMAIN}` });
    mixpanel.reset();
  }

  emitAuthenticationTokenStore(accessToken?: IJWTUserPayload): void {
    if (accessToken) {
      this._authStateService.setAccessToken(accessToken);
    } else {
      this._authStateService.resetAccessToken();
    }
  }
}
